import NationalDashboard from '../../organization/NationalDashboard.jsx'

/**
 * Value & Impact tab — reuses the existing National Value & Impact
 * dashboard (savings, ROI, avoided visits, platform economics) verbatim
 * so the commercial story lives alongside the population-health
 * intelligence in one integrated platform. This component manages its own
 * data fetch and window selector, so it ignores the parent's props.
 */
export default function ValueImpact() {
  return <NationalDashboard />
}
